module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_8019.2fa7822b.png";